module.exports = __webpack_public_path__ + "img/recCollect.bb0a8c68.svg";